<template>
  <div
    id="modalDashboard"
    class="proModalDashboard modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalDashboard"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="pull-right">
            <button
              class="btn"
              data-dismiss="modal"
              aria-label="Close"
              @click="close()"
            >
              <span>
                <pb-icon class="fas fa-times" />
              </span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <div v-for="(content, index) of contentFiltered" :key="index" class="text-center">
            <div
              v-show="indexContentVisible === index"
              :class="{ 'embed-responsive embed-responsive-16by9': isResponsiveEmbed(index), 'cursor-pointer': hasAction(content) }"
              @click="action(content)"
              v-html="content.html"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDashboard',
  data() {
    return {
      banners: [],
      portal: this.$portal,
      user: this.$user,
      company: this.$company,
      viewModal: false,
      contents: [],
      indexContentVisible: 0,
      timeout: '',
    };
  },

  computed: {
    contentFiltered() {
      return this.banners;
    },
  },
  mounted() {
    window.addEventListener('resize', this.hideMobile);

    $('.proModalDashboard').on('hidden.bs.modal', () => {
      this.close();
    });

    $('.proModalDashboard').on('shown.bs.modal', async e => {
      await this.getContentList();
      this.hideMobile(e);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.hideMobile);
    $('.modal-dialog').css({ width: '', height: '' });
  },
  methods: {
    closeOverlay(isValid) {
      if (isValid === false)
        this.close();
    },

    close() {
      $('.proModalDashboard').modal('hide');
      $('.modal-dialog').css({ width: '', height: '' });
      this.contents = [];
      clearTimeout(this.timeout);
    },
    async getContentList(index = 0) {
      this.banners = await brain.getBanners();
      if (Array.isArray(this.banners)) {
        this.contents = this.banners.filter(i => i && i.html);
        this.changeContentVisibility();
      }
    },
    isResponsiveEmbed(index) {
      if (_.get(this.company, `json.modalDashboard.items[${index}].responsive`) !== true) return false;
      return true;
    },
    hasAction({ link } = {}) {
      if (!link) return false;
      return true;
    },
    action({ link } = {}) {
      if (!this.hasAction({ link })) return;

      if (link.includes('http')) { window.open(link, '_blank'); } else {
        const [moduleId, itemId] = link.split('/');

        brain.openModuleById({ moduleId, itemId });
      }
    },
    changeContentVisibility(index = 0) {
      if (this.isResponsiveEmbed(index)) $('.modal-dialog').css({ width: '75%', height: '75%' });
      else $('.modal-dialog').css({ width: '', height: '' });

      if (!this.contentFiltered[index]) index = 0;

      this.indexContentVisible = index;

      if (this.contentFiltered.length <= 1) {
        if (this.timeout) clearTimeout(this.timeout);
        return;
      }
      const timeout = Number(this.contentFiltered[this.indexContentVisible].timeout) * 1000 || 5 * 1000;

      this.timeout = setTimeout(() => this.changeContentVisibility(this.indexContentVisible + 1), timeout);
    },
    hideMobile(e) {
      const { target } = e || {};

      if (!this.contentFiltered.length || this.contentFiltered.some((i, index) => this.isResponsiveEmbed(index))) return;

      if (target.innerWidth <= 768) this.close();
    },
  },
};
</script>

<style scoped lang="scss">
.modal {
  .modal-content {
    background-color: transparent;
    border: none;
    box-shadow: none;
    height: 100%;
    width: 100%;
  }
  .modal-body {
    padding: 0px 0px 0px 0px;
    height: 100%;
    width: 100%;
  }

  .modal-dialog {
    @media (max-width: 767px) {
      margin: 15px auto;
    }
  }

  button {
    opacity: 0.75;
  }
  button:hover {
    opacity: 1;
  }
  .modal-header {
    border: 0 !important;
    padding: 15px 0 15px 0 !important;
  }
}
</style>
